/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-10-27 09:07:48
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-11-09 16:10:22
 * @FilePath: \minipro-manger\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
// axios.defaults.baseURL = 'https://localhost:8080/'
Vue.prototype.axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
